module.exports = __webpack_public_path__ + "3f1d89e4eb9f2777bba03089abdea0c4.png";